import { render, staticRenderFns } from "./orderInvoice.vue?vue&type=template&id=66c785de&"
import script from "./orderInvoice.vue?vue&type=script&lang=js&"
export * from "./orderInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports